import RedirectToClient from './RedirectToClient';

export default RedirectToClient;
